import {Field, reduxForm} from 'redux-form'
import {connect} from 'react-redux'
import {businessTypes, businessCategories, redirectTo} from 'actions'
import styles from './style.css'
import PhoneNumberField from 'components/Fields/ReduxForm/PhoneNumberField'

const validate = values => {
  const errors = {}
  if (!values.businessName) {
    errors.businessName = 'This field is required'
  }
  if (!values.businessType) {
    errors.businessType = 'This field is required'
  }
  if (!values.businessCategory) {
    errors.businessCategory = 'This field is required'
  }
  if (!values.businessAddress) {
    errors.businessAddress = 'This field is required'
  }
  if (!values.businessCity) {
    errors.businessCity = 'This field is required'
  }
  if (!values.businessProvince) {
    errors.businessProvince = 'This field is required'
  }
  if (!values.businessPostalCode) {
    errors.businessPostalCode = 'This field is required'
  } else if (!/^\d{5}$/.test(values.businessPostalCode)) {
    errors.businessPostalCode = 'Please enter a valid format'
  }
  if (!values.userFirstName) {
    errors.userFirstName = 'This field is required'
  }
  if (!values.userLastName) {
    errors.userLastName = 'This field is required'
  }
  if (!values.userPhone) {
    errors.userPhone = 'This field is required'
  }
  return errors
}

const inputField = (field) => {
  return (
    <div>
      <input {...field.input}
        type={field.type || 'text'}
        maxLength={field.maxLength}
        className='form-control'
        placeholder={field.placeholder}
        onKeyPress={(e) => field.onKeyPress ? field.setOnlyNumber(e) : ''}
        keyboardType={field.keyboardType}
        />
      <small className='error'>{field.meta.touched ? field.meta.error : ''}</small>
    </div>
  )
}

const renderSelectField = ({ input, label, type, meta: { touched, error }, children }) => (
  <div>
    <div>
      <select {...input} className='form-control'>
        {children}
      </select>
      <small className='error'>{touched ? error : ''}</small>
    </div>
  </div>
)

let ProfileSetupForm = class profileSetupForm extends React.Component {
  componentDidMount () {
    var userRegState = this.props.data.moka.formRegState
    if (!userRegState.email || !userRegState.password || !userRegState.confpassword) {
      this.props.dispatch(redirectTo('register'))
    }
    this.props.dispatch(businessTypes())
  }

  render () {
    let {handleSubmit} = this.props
    return (
      <form onSubmit={handleSubmit}>
        <div className='row'>
          <div className='col-lg-12'>
            <div className={styles['mk-sub-section-header']}>business information </div>
          </div>
        </div>
        <div>
          <div className='row'>
            <div className='col-md-12 col-lg-12 col-sm-12'>
              <div className={styles['form-group']}>
                <label htmlFor='businessName' className='sr-only'>Business Name</label>
                <Field
                  component={inputField}
                  name='businessName'
                  maxLength='100'
                  placeholder='Business Name'
                  autoCorrect='off'
                  autoCapitalize='off'
                  spellCheck='false' />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 col-lg-6 col-sm-12'>
              <div className={styles['form-group'] + ' ' + styles['margin-bottom-5']}>
                <label htmlFor='businessType' className='sr-only'>Business Type</label>
                <Field
                  name='businessType'
                  className='form-control'
                  onChange={this.handleChangeBusinessType}
                  id='business_type_id'
                  component={renderSelectField}>
                  <option key={0} value=''>- Business Type -</option>
                  { this.props.businessTypes.map(option => <option value={option.id} key={option.id}>{option.name}</option>) }
                </Field>
                <br />
              </div>
            </div>
            <div className='col-md-6 col-lg-6 col-sm-12'>
              <div className={styles['form-group'] + ' ' + styles['margin-bottom-5']}>
                <label htmlFor='businessCategory' className='sr-only'>Business Category</label>
                <Field
                  name='businessCategory'
                  className='form-control'
                  id='business_category_id'
                  component={renderSelectField}>
                  <option key={0} value=''>- Category -</option>
                  { this.props.businessCategories.map(option => <option value={option.id} key={option.id}>{option.name}</option>) }
                </Field>
                <br />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 col-lg-12 col-sm-12'>
              <div className={styles['form-group']}>
                <label htmlFor='businessAddress' className='sr-only'>Address</label>
                <Field
                  component={inputField}
                  name='businessAddress'
                  placeholder='Address'
                  maxLength='255'
                  autoCorrect='off'
                  autoCapitalize='off'
                  spellCheck='false' />
              </div>
            </div>
          </div>
          <div className={'row ' + styles['divider-business-information']}>
            <div className='col-md-4 col-lg-4 col-sm-12'>
              <div className={styles['form-group']}>
                <label htmlFor='businessCity' className='sr-only'>Business City</label>
                <Field
                  component={inputField}
                  name='businessCity'
                  placeholder='City'
                  maxLength='50'
                  autoCorrect='off'
                  autoCapitalize='off'
                  spellCheck='false' />
              </div>
            </div>
            <div className='col-md-4 col-lg-4 col-sm-12'>
              <div className={styles['form-group']}>
                <label htmlFor='businessState' className='sr-only'>Business State</label>
                <Field
                  component={inputField}
                  name='businessProvince'
                  maxLength='50'
                  placeholder='State'
                  autoCorrect='off'
                  autoCapitalize='off'
                  spellCheck='false' />
              </div>
            </div>
            <div className='col-md-4 col-lg-4 col-sm-12'>
              <div className={styles['form-group']}>
                <label htmlFor='businessZipCode' className='sr-only'>Business Zip Code</label>
                <Field
                  component={inputField}
                  name='businessPostalCode'
                  maxLength='5'
                  placeholder='Zip'
                  autoCorrect='off'
                  type='tel'
                  autoCapitalize='off'
                  onKeyPress
                  setOnlyNumber={this.setOnlyNumber}
                  spellCheck='false'
                  keyboardType='numeric' />
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-lg-12'>
            <div className={styles['mk-divider-section-line']} />
          </div>
        </div>
        <div className='row'>
          <div className='col-lg-12'>
            <div className={styles['mk-sub-section-header']}>user information</div>
          </div>
        </div>
        <div>
          <div className='row'>
            <div className='col-md-6 col-lg-6 col-sm-12'>
              <div className={styles['form-group']}>
                <label htmlFor='firstName' className='sr-only'>First Name</label>
                <Field
                  component={inputField}
                  name='userFirstName'
                  placeholder='First Name'
                  autoCorrect='off'
                  maxLength='30'
                  autoCapitalize='off'
                  spellCheck='false' />
              </div>
            </div>
            <div className='col-md-6 col-lg-6 col-sm-12'>
              <div className={styles['form-group']}>
                <label htmlFor='lastName' className='sr-only'>Last Name</label>
                <Field
                  component={inputField}
                  name='userLastName'
                  placeholder='Last Name'
                  autoCorrect='off'
                  maxLength='30'
                  autoCapitalize='off'
                  spellCheck='false' />
              </div>
            </div>
          </div>
          <div className='row mb-20px;'>
            <div className='col-md-12 col-lg-12 col-sm-12'>
              <div className={styles['form-group']}>
                <label htmlFor='Phone' className='sr-only'>Phone</label>
                <Field
                  component={PhoneNumberField}
                  name='userPhone'
                  type='tel'
                  placeholder='812'
                  showTextError />
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-lg-12'>
            <div className={styles['mk-divider-section-line']} />
          </div>
        </div>
        <div className={'row ' + styles['row-continue']}>
          <div className='col-lg-12'>
            <button className='btn btn-primary pull-right' type='submit' onClick={this._onClickSubmitButton}>Continue</button>
          </div>
        </div>
      </form>
    )
  }

  handleChangeBusinessType = (event) => {
    this.props.change('businessCategory', '')
    this.props.dispatch(businessCategories(event.target.value))
    this.props.change('businessType', event.target.value)
  }

  _handleSubmit = () => {
    this.props.handleSubmit()
  }

  setOnlyNumber (e) {
    const regex = /[0-9:]+/g
    if (!regex.test(e.key)) {
      e.preventDefault()
    }
  }
}

ProfileSetupForm.propTypes = {
  dispatch: React.PropTypes.func,
  data: React.PropTypes.object,
  onSubmit: React.PropTypes.func,
  error: React.PropTypes.object,
  currentlySending: React.PropTypes.bool,
  businessTypes: React.PropTypes.array,
  businessCategories: React.PropTypes.array
}

ProfileSetupForm = reduxForm({
  form: 'profileSetupForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate
})(ProfileSetupForm)

function select (state) {
  return {
    data: state
  }
}

export default connect(select)(ProfileSetupForm)



// WEBPACK FOOTER //
// ./app/pages/Register/ProfileSetupForm.js